webpackJsonp([14],{

/***/ 146:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(146);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _bootstrapDatepicker = __webpack_require__(65);

var _bootstrapDatepicker2 = _interopRequireDefault(_bootstrapDatepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// On mail sent event


// Vendors
document.addEventListener('wpcf7mailsent', function (event) {
  var inputs = event.detail.inputs;
  var firstname = '';
  for (var i = 0; i < inputs.length; i++) {
    if (inputs[i].name == 'firstname') {
      firstname = inputs[i].value;
    }
  }

  // Send to Thank You Page
  if (firstname.length > 0) {
    window.location.href = '/careers/thank-you/?first_name=' + firstname;
  }
}, false);

// Allow clicking on checkbox/radio labels for better UX
// Disabling because it breaks conditional field functionality
// $('.wpcf7-checkbox .wpcf7-list-item-label').on('click', event => {
//   const input = $(event.currentTarget).prev();
//   input.prop('checked', !input[0].checked);
// });
// $('.wpcf7-radio .wpcf7-list-item-label').on('click', event => {
//   const input = $(event.currentTarget).prev();
//   input.prop('checked', true);
// });

// Add blank option to select
/**
 * Careers JS
 */

// CSS
(0, _jquery2.default)('.wpcf7-form select option').first().html('');

// Wrap button
(0, _jquery2.default)('.wpcf7-form .btn').wrapInner('<span></span>');

// Datepicker
(0, _jquery2.default)('#date').datepicker({});

// Handle upload buttons
(0, _jquery2.default)('button[data-target]').on('click', function (event) {
  var targetFileInput = (0, _jquery2.default)(event.currentTarget).data('target');
  (0, _jquery2.default)('input[type="file"][name=' + targetFileInput + ']').click();

  if (!(0, _jquery2.default)(event.currentTarget).next().is('.file-input-value-display')) {
    (0, _jquery2.default)(event.currentTarget).after('<span class="file-input-value-display"></span>');
    (0, _jquery2.default)(event.currentTarget).next().css('margin-left', '15px');
  }

  setInterval(function () {
    var fileName = void 0;
    var fileInput = (0, _jquery2.default)('input[type="file"][name=' + targetFileInput + ']');

    if (typeof fileInput.val() !== 'undefined') {
      fileName = fileInput.val().split('/').pop().split('\\').pop();
      (0, _jquery2.default)(event.currentTarget).next().html(fileName);
    }
  }, 1000);
});

// Add website button
(0, _jquery2.default)('#add-site').on('click', function (event) {
  event.preventDefault();

  if ((0, _jquery2.default)('.site-hidden-input').length === 1) {
    (0, _jquery2.default)(event.currentTarget).hide();
  }

  (0, _jquery2.default)('.site-hidden-input').first().removeClass('site-hidden-input');
});

// Show form
setTimeout(function () {
  (0, _jquery2.default)('.wpcf7-form').addClass('ready');
}, 200);

/***/ })

},[168]);


// WEBPACK FOOTER //
// careers.8b8d8af1.js